import React from "react";
import { FaClipboardList } from "react-icons/fa";
import "../../stylez/CoachEvaluation.css";

const CoachEvaluationLink = () => {
  const handleEvaluationClick = () => {
    window.open(
      "https://docs.google.com/forms/d/1fxvYM158ssslUP-QlN3wnbzThAT2CcovGj4XgQp32Ck/viewform",
      "_blank"
    );
  };

  return (
    <div className="coach-evaluation-container">
      <h2 className="coach-evaluation-title">Coach Evaluation</h2>
      <div className="coach-evaluation-link">
        <div className="evaluation-card" onClick={handleEvaluationClick}>
          <div className="evaluation-icon">
            <FaClipboardList size={40} />
          </div>
          <div className="evaluation-text">
            <h3>Evaluate a Coach's Class</h3>
            <p>Share your feedback on a fellow coach's performance</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachEvaluationLink;
